export default {
  namespaced: true,
  state: {
    isSuperUser: false,
    user_detail: null,
  },
  getters: {
    getSuperUser: (state) => state.isSuperUser,
  },
  mutations: {
    TOGGLE_SUPER_USER(state, obj) {
      state.isSuperUser = obj.super_user;
    },
    TOGGLE_USER_DETAIL(state, obj) {
      state.user_detail = obj;
    },
  },
  actions: {
    toggleSuperUser({ commit }, obj) {
      commit("TOGGLE_SUPER_USER", obj);
    },
    toggleUserDetail({ commit }, obj) {
      commit("TOGGLE_USER_DETAIL", obj);
    },
  },
};
